export const FloralBranch = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 220 120"
    fill="none"
    className={className}
    style={flip ? { transform: "scaleX(-1)" } : undefined}
    aria-hidden="true"
  >
    <g stroke="var(--gold)" strokeWidth="1" strokeLinecap="round" opacity="0.75">
      <path d="M8 112 C 50 95, 110 70, 205 18" />
      <path d="M52 92 C 48 78, 54 66, 66 60" />
      <path d="M52 92 C 62 84, 74 84, 82 90" />
      <path d="M98 72 C 92 60, 96 46, 108 40" />
      <path d="M98 72 C 108 66, 120 66, 128 74" />
      <path d="M148 48 C 142 38, 146 26, 156 20" />
      <path d="M148 48 C 158 44, 168 46, 174 54" />
      <ellipse cx="66" cy="57" rx="4.5" ry="8" transform="rotate(-35 66 57)" />
      <ellipse cx="84" cy="92" rx="4" ry="7" transform="rotate(55 84 92)" />
      <ellipse cx="110" cy="37" rx="4.5" ry="8" transform="rotate(-30 110 37)" />
      <ellipse cx="130" cy="76" rx="4" ry="7" transform="rotate(60 130 76)" />
      <ellipse cx="158" cy="17" rx="4" ry="7.5" transform="rotate(-25 158 17)" />
      <ellipse cx="176" cy="56" rx="3.5" ry="6.5" transform="rotate(65 176 56)" />
      <circle cx="205" cy="18" r="3" fill="var(--gold-soft)" stroke="none" opacity="0.9" />
      <circle cx="196" cy="26" r="1.6" fill="var(--gold)" stroke="none" />
      <circle cx="30" cy="103" r="1.4" fill="var(--gold)" stroke="none" />
    </g>
  </svg>
);

export const MonogramCrest = ({ initial1 = "R", initial2 = "S", className = "" }) => (
  <svg viewBox="0 0 240 240" fill="none" className={className} aria-hidden="true">
    <defs>
      <g id="crest-quad" stroke="var(--gold-soft)" strokeWidth="1.1" strokeLinecap="round" fill="none">
        <path d="M46 118 C 58 84, 82 58, 114 38" />
        <ellipse cx="55" cy="98" rx="2.8" ry="6.5" transform="rotate(-62 55 98)" />
        <ellipse cx="63" cy="92" rx="2.6" ry="6" transform="rotate(-12 63 92)" />
        <ellipse cx="68" cy="76" rx="2.8" ry="6.5" transform="rotate(-72 68 76)" />
        <ellipse cx="77" cy="72" rx="2.6" ry="6" transform="rotate(-22 77 72)" />
        <ellipse cx="85" cy="58" rx="2.8" ry="6.5" transform="rotate(-82 85 58)" />
        <ellipse cx="94" cy="56" rx="2.6" ry="6" transform="rotate(-32 94 56)" />
        <ellipse cx="103" cy="45" rx="2.8" ry="6.2" transform="rotate(-88 103 45)" />
        <path d="M50 108 c -6 -2, -9 -7, -8 -13 c 6 1, 9 6, 8 13 Z" />
        <circle cx="58" cy="84" r="1.2" fill="var(--gold-soft)" stroke="none" />
        <circle cx="90" cy="48" r="1.2" fill="var(--gold-soft)" stroke="none" />
      </g>
      <g id="crest-bloom" stroke="var(--gold-soft)" strokeWidth="1.1" strokeLinecap="round" fill="none">
        <path d="M120 34 c -4 -5, -4 -11, 0 -15 c 4 4, 4 10, 0 15 Z" />
        <path d="M120 34 c -6 -1, -9 -5, -9 -10 c 5 0, 8 4, 9 10" />
        <path d="M120 34 c 6 -1, 9 -5, 9 -10 c -5 0, -8 4, -9 10" />
      </g>
    </defs>
    <use href="#crest-quad" />
    <use href="#crest-quad" transform="scale(-1,1) translate(-240,0)" />
    <use href="#crest-quad" transform="scale(1,-1) translate(0,-240)" />
    <use href="#crest-quad" transform="scale(-1,-1) translate(-240,-240)" />
    <use href="#crest-bloom" />
    <use href="#crest-bloom" transform="scale(1,-1) translate(0,-240)" />
    <use href="#crest-bloom" transform="rotate(-90 120 120)" />
    <use href="#crest-bloom" transform="rotate(90 120 120)" />
    <path
      d="M120 52 C 150 70, 172 92, 184 120 C 172 148, 150 170, 120 188 C 90 170, 68 148, 56 120 C 68 92, 90 70, 120 52 Z"
      stroke="var(--gold-soft)"
      strokeWidth="0.9"
      opacity="0.85"
    />
    <path
      d="M120 58 C 147 74, 167 94, 178 120 C 167 146, 147 166, 120 182 C 93 166, 73 146, 62 120 C 73 94, 93 74, 120 58 Z"
      stroke="var(--gold-soft)"
      strokeWidth="0.6"
      opacity="0.6"
    />
    <text
      x="104"
      y="136"
      textAnchor="middle"
      fontFamily="'Tangerine', cursive"
      fontSize="64"
      fill="var(--gold)"
    >
      {initial1}
    </text>
    <text
      x="136"
      y="154"
      textAnchor="middle"
      fontFamily="'Tangerine', cursive"
      fontSize="64"
      fill="var(--gold)"
    >
      {initial2}
    </text>
  </svg>
);

export const OrnamentDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
    <div className="hairline w-16 sm:w-24" />
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none">
      <path
        d="M12 3 C 13 8, 16 11, 21 12 C 16 13, 13 16, 12 21 C 11 16, 8 13, 3 12 C 8 11, 11 8, 12 3 Z"
        stroke="var(--gold)"
        strokeWidth="0.9"
      />
    </svg>
    <div className="hairline w-16 sm:w-24" />
  </div>
);
